export default __webpack_public_path__ + "static/media/simonSound1.be139b4b.mp3";